import { Component, AfterViewInit, Input, ViewChild, OnDestroy } from '@angular/core';
import { GridOptions } from './ag-grid.model';
declare var agGrid: any;
@Component({
    selector: 'app-grid',
    templateUrl: './ag-grid.component.html',
    styleUrls: ['./ag-grid.component.scss']
})
export class AgGridComponent implements AfterViewInit, OnDestroy {
    gridOptions: GridOptions;
    columnDefs = [];
    subscribers = [];
    rowData = [];
    @ViewChild('myGrid') myGrid;
    @Input() set options(value: GridOptions) {
        this.gridOptions = value;
        this.setGrid();
        this.initEvents();
    }
    constructor() {

    }
    initEvents() {
        this.subscribers.push(
            this.gridOptions.onSetData$.subscribe((data: any[]) => {
                this.rowData = data;
                this.gridOptions.rowData = data;
                this.setGrid();
            }),
        )
    }

    setGrid() {
        const that = this;
        if (this.myGrid) {
            this.processGridOptions();
            const eGridDiv = this.myGrid.nativeElement;
            eGridDiv.innerHTML = '';
            setTimeout(() => {
                const grid = new agGrid.Grid(eGridDiv, this.gridOptions);
            }, 300);
        } else {
            setTimeout(() => {
                that.setGrid();
            }, 50);
        }
    }
    ngAfterViewInit() {
    }

    processGridOptions() {
        // tslint:disable-next-line: one-variable-per-declaration
        const options = this.gridOptions,
            columns = options.columnDefs;
        if (!(columns[0] && columns[0].field == '_sno')) {
            columns.splice(0, 0, {
                headerName: 'S.no',
                field: '_sno',
                pinned: 'left',
                width: 50,
                cellRenderer: (a) => {
                    if (a.node.floating) {
                        return '';
                    }
                    return a.rowIndex + 1;
                }
            });
        }
        columns.map((column) => {
            column.onCellClicked = (e) => {
                console.log('on Cell Clicked', e);
            };
            if (column.summary || column.type === 'number') {
                if (column.cellClass) {
                    column.cellClass += ' align-right';
                } else {
                    column.cellClass = 'align-right';
                }
            }
            if (column.summary) {
                if (column.field !== '_sno') {
                    column.floatingCellRenderer = (a) => {
                        return this.calcSummaryValue(this.gridOptions.rowData, column.field, column.summary);
                    };
                }
            } else if (column.field === '_sno') {
                column.cellClass += ' sno-col';
            }
            if (typeof (column.field) === 'undefined') {
                column.field = (column.headerName || '').toLowerCase();
            }
        });
    }

    calcSummaryValue(rows: any[], property = '', type = 'sum') {
        let value = 0;
        const round = (no) => {
            return Math.round(no * 100) / 100;
        };
        switch (type) {
            case 'avg':
                rows.map((row) => {
                    value += row[property];
                });
                return rows.length ? round(value / rows.length) : 0;
            case 'sum':
            default:
                rows.map((row) => {
                    value += row[property];
                });
                return round(value);
        }
    }
    ngOnDestroy() {
        this.subscribers.map((subscriber) => {
            subscriber.unsubscribe();
        });
    }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/common/ag-grid/ag-grid.component.ts